<template>
  <h1>Failed to load</h1>
</template>
